// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2650) return "static/chunks/2650-f404c3475a49b4d8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1160":"28d2f374adc59d8e","3681":"10906efc282673e3","4316":"2d39a75ca028bd48","4414":"2b0c61b06f3b6e8b","6966":"ec1e7cbad4dfe584","6975":"7d60cdf1f6b0338f"}[chunkId] + ".js";
};